import { c as _c } from "react/compiler-runtime";
import { BreadcrumbsData, NeutralButton, PrimaryButton, toast } from '@systemeio/ui';
import { BadRequest } from '@systemeio/util';
import { PayloadTooLarge } from '@systemeio/util';
import { SendTestEmailModal } from 'modules/mailing/components/send-test-email-modal';
import { getEmailStatisticsUrl } from 'modules/mailing/email-statistics/utils/get-email-statistics-url';
import { DuplicateNewsletterModal } from 'modules/newsletters/single/components/duplicate-newsletter-modal';
import { SaveAndSendNewsletterModal } from 'modules/newsletters/single/components/save-and-send-newsletter-modal';
import { ScheduleNewsletterModal } from 'modules/newsletters/single/components/schedule-newsletter-modal';
import { newsletterDefaultErrors } from 'modules/newsletters/single/constants/newsletter-default-errors';
import { useGetNewsletterView } from 'modules/newsletters/single/hooks/use-get-newsletter-view';
import { useNewsletterContactsSettings } from 'modules/newsletters/single/hooks/use-newsletter-contacts-settings';
import { useUpdateNewsletter } from 'modules/newsletters/single/hooks/use-update-newsletter';
import { NewsletterErrorResponseContentInterface } from 'modules/newsletters/single/types/error-response-content-interface';
import { NewsletterId } from 'modules/newsletters/single/types/newsletter-interface';
import { NewsletterViewApiInterface } from 'modules/newsletters/single/types/newsletter-view-interface';
import { getNewslettersListNextjsUrl } from 'modules/newsletters/single/utils/get-newsletters-list-nextjs-url';
import { setNewsletterEmailErrors } from 'modules/newsletters/single/utils/set-newsletter-email-errors';
import { transformToNewsletterData } from 'modules/newsletters/single/utils/transform-to-newsletter-data';
import { useTagsAll } from 'modules/tags/hooks/use-tags-all';
import { useEffect, useState } from 'react';
import BreadcrumbsDashboard from 'shared/components/breadcrumbs';
import { ButtonWithDropdown } from 'shared/components/buttin-with-dropdown/button-with-dropdown';
import { ButtonWithDropdownTypeEnum } from 'shared/components/buttin-with-dropdown/enums/button-with-dropdown-type-enum';
import DashboardMailEditor from 'shared/components/dashboard-mail-editor';
import { useMailingState } from 'shared/components/dashboard-mail-editor/hooks/use-mailing-state';
import { useUnsavedEmail } from 'shared/components/dashboard-mail-editor/hooks/use-unsaved-email';
import { TempStateType } from 'shared/components/dashboard-mail-editor/types/temp-state-type';
import { getMailingUpdateData } from 'shared/components/dashboard-mail-editor/utils/get-mailing-update-data';
import { validateEmailBeforeSave } from 'shared/components/dashboard-mail-editor/utils/validate-email-before-save';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { ConfirmationModalBeforeExit } from 'shared/confirmation-modal-before-exit/component';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { deepCompare } from 'shared/utils/deepCompare';
import { CreateSplitTestModal } from '../split-test/components/create-split-test-modal';
import { CloseIcon, EventIcon, SendEmailIcon, StatisticsIcon, TestTubeIcon } from '@systemeio/ui/icons';
interface NewsletterSingleProps {
  newsletterId: NewsletterId;
  newsletterData: NewsletterViewApiInterface;
}
export const NewsletterSingle = t0 => {
  const $ = _c(84);
  const {
    newsletterId,
    newsletterData
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    isRestrictedUser
  } = useUser();
  const [isFetching, setIsFetching] = useState(false);
  const {
    isFetchingChooseEmailTemplate,
    onChangeEmail,
    tempState,
    setAttachmentsTempState,
    attachmentsTempState,
    errors,
    setErrors,
    setDefaultErrors
  } = useMailingState({
    mailing: newsletterData.mailing,
    onSave: data => onSave(data, {
      throwError: true
    }),
    defaultErrors: newsletterDefaultErrors
  });
  const {
    contactsSettings,
    setContactsSettings
  } = useNewsletterContactsSettings(newsletterData);
  const [isDataSaved, setIsDataSaved] = useState(true);
  const {
    fetcherUpdateNewsletter
  } = useUpdateNewsletter(newsletterId);
  let t1;
  if ($[0] !== newsletterId) {
    t1 = {
      newsletterId
    };
    $[0] = newsletterId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    mutateNewslettersData
  } = useGetNewsletterView(t1);
  const {
    tags: listOfTags
  } = useTagsAll();
  const isLoading = isFetching || isFetchingChooseEmailTemplate;
  const isTagsSelected = !!contactsSettings.tags.included.length;
  let t2;
  if ($[2] !== t) {
    t2 = t("dashboard.newsletter.newsletters");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = getNewslettersListNextjsUrl();
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = {
      caption: t2,
      href: t3,
      isStatic: true
    };
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== newsletterData.mailing.currentEmail.subject) {
    t5 = {
      caption: newsletterData.mailing.currentEmail.subject
    };
    $[7] = newsletterData.mailing.currentEmail.subject;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = [t4, t5];
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const breadcrumbsData = t6;
  const t7 = tempState?.body;
  let t8;
  if ($[12] !== onChangeEmail || $[13] !== tempState) {
    t8 = data_0 => onChangeEmail({
      ...tempState,
      body: data_0
    });
    $[12] = onChangeEmail;
    $[13] = tempState;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== newsletterData.mailing.currentEmail.body || $[16] !== newsletterData.mailing.id || $[17] !== t7 || $[18] !== t8) {
    t9 = {
      mailingId: newsletterData.mailing.id,
      currentBody: t7,
      initialBody: newsletterData.mailing.currentEmail.body,
      showImmediately: true,
      onPaste: t8
    };
    $[15] = newsletterData.mailing.currentEmail.body;
    $[16] = newsletterData.mailing.id;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const {
    UnsavedEmailConfirmationModal,
    removeDbRecord
  } = useUnsavedEmail(t9);
  const onSave = async (newData, options) => {
    ;
    try {
      setDefaultErrors();
      validateEmailBeforeSave(newData.fromEmail, setErrors, t);
      setIsFetching(true);
      const responseData = await fetcherUpdateNewsletter({
        tags: contactsSettings.tags.included,
        excludedTags: contactsSettings.tags.excluded,
        daysExists: contactsSettings.daysExists,
        mailing: {
          currentEmail: getMailingUpdateData(newData, attachmentsTempState)
        }
      });
      await mutateNewslettersData(transformToNewsletterData({
        listOfTags,
        attachmentsTempState: responseData.mailing.currentEmail.attachments,
        tempState: newData,
        contactsSettings,
        newsletterData
      }), false);
      toast.success(t("global.changes_saved"));
      setIsFetching(false);
      await removeDbRecord();
    } catch (t10) {
      const e = t10;
      setIsFetching(false);
      toast.error(t("global.error"));
      if (e instanceof BadRequest) {
        const errors_0 = e.errors as NewsletterErrorResponseContentInterface;
        const currentMailing = !Array.isArray(errors_0.fields) ? errors_0.fields.mailing : undefined;
        if (currentMailing) {
          setNewsletterEmailErrors(setErrors, currentMailing.currentEmail);
        }
        if (errors_0.common) {
          const commonErrors = errors_0.common;
          setErrors(prev => ({
            ...prev,
            common: commonErrors
          }));
        }
      } else {
        if (e instanceof PayloadTooLarge) {
          toast.error(t("core.error.payload_to_large_error_message"));
        }
      }
      if (options?.throwError) {
        throw e;
      }
    }
  };
  let t11;
  if ($[20] !== attachmentsTempState || $[21] !== contactsSettings || $[22] !== listOfTags || $[23] !== newsletterData || $[24] !== setIsDataSaved || $[25] !== tempState) {
    t11 = () => {
      setIsDataSaved(deepCompare(transformToNewsletterData({
        listOfTags,
        tempState,
        attachmentsTempState,
        contactsSettings,
        newsletterData
      }), newsletterData));
    };
    $[20] = attachmentsTempState;
    $[21] = contactsSettings;
    $[22] = listOfTags;
    $[23] = newsletterData;
    $[24] = setIsDataSaved;
    $[25] = tempState;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== attachmentsTempState || $[28] !== contactsSettings || $[29] !== listOfTags || $[30] !== newsletterData || $[31] !== tempState) {
    t12 = [attachmentsTempState, contactsSettings, listOfTags, newsletterData, tempState];
    $[27] = attachmentsTempState;
    $[28] = contactsSettings;
    $[29] = listOfTags;
    $[30] = newsletterData;
    $[31] = tempState;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  useEffect(t11, t12);
  const t13 = !newsletterData;
  let t14;
  if ($[33] !== breadcrumbsData || $[34] !== t13) {
    t14 = <BreadcrumbsDashboard data={breadcrumbsData} isFetching={t13} />;
    $[33] = breadcrumbsData;
    $[34] = t13;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== isFetching || $[37] !== isLoading || $[38] !== isRestrictedUser || $[39] !== isTagsSelected || $[40] !== mutateNewslettersData || $[41] !== newsletterData.mailing.id || $[42] !== newsletterData.scheduledAt || $[43] !== newsletterData.sent || $[44] !== newsletterId || $[45] !== onSave || $[46] !== t || $[47] !== tempState) {
    t15 = newsletterData.sent ? <><PrimaryButton as={LinkWithoutPrefetch} aria-disabled={isLoading} href={getEmailStatisticsUrl(newsletterData.mailing.id)}><StatisticsIcon className="h-[20px] w-[20px]" /><span className="hidden lg:flex">{t("dashboard.newsletter_editor.statistics")}</span></PrimaryButton><DuplicateNewsletterModal newsletterId={newsletterId} isDisabled={isLoading} /></> : <>{!newsletterData.scheduledAt && <CreateSplitTestModal newsletterId={newsletterId} isDisabled={isLoading} />}<ButtonWithDropdown options={[{
        name: "SendTestEmailModal",
        menuItem: {
          title: t("dashboard.newsletter_editor.save_and_test"),
          icon: <TestTubeIcon className="fill-text-primary h-[18px] w-[18px]" />,
          disabled: !!isRestrictedUser
        },
        type: ButtonWithDropdownTypeEnum.Button,
        onActionRender: (opened, onClose, key) => <SendTestEmailModal mailingId={newsletterData.mailing.id} onSave={() => onSave(tempState, {
          throwError: true
        })} opened={opened} onClose={onClose} key={key} />
      }, {
        name: "SaveAndSendNewsletterModal",
        menuItem: {
          title: t("dashboard.newsletter_editor.save_and_send"),
          icon: <SendEmailIcon className="fill-text-primary h-[18px] w-[18px]" />,
          disabled: !!isRestrictedUser
        },
        type: ButtonWithDropdownTypeEnum.Button,
        onActionRender: (opened_0, onClose_0, key_0) => <SaveAndSendNewsletterModal opened={opened_0} onClose={onClose_0} key={key_0} newsletterId={newsletterId} onSave={() => onSave(tempState, {
          throwError: true
        })} confirmationText={t("dashboard.newsletter_editor.send_confirm")} isTagsSelected={isTagsSelected} />
      }, {
        name: "ScheduleNewsletterModal",
        menuItem: {
          title: t("dashboard.newsletter_editor.save_and_schedule"),
          icon: <EventIcon className="fill-text-primary h-[18px] w-[18px]" />,
          disabled: !!isRestrictedUser
        },
        type: ButtonWithDropdownTypeEnum.Button,
        onActionRender: (opened_1, onClose_1, key_1) => <ScheduleNewsletterModal title={t("dashboard.newsletter.schedule_modal_title")} opened={opened_1} isTagsSelected={isTagsSelected} onClose={onClose_1} key={key_1} scheduledAt={newsletterData.scheduledAt} newsletterId={newsletterId} onSave={() => onSave(tempState, {
          throwError: true
        })} mutateNewslettersData={mutateNewslettersData} />
      }]} disabled={isLoading} onClick={() => onSave(tempState)} title={t("global.save_draft")} isFetching={isFetching} /></>;
    $[36] = isFetching;
    $[37] = isLoading;
    $[38] = isRestrictedUser;
    $[39] = isTagsSelected;
    $[40] = mutateNewslettersData;
    $[41] = newsletterData.mailing.id;
    $[42] = newsletterData.scheduledAt;
    $[43] = newsletterData.sent;
    $[44] = newsletterId;
    $[45] = onSave;
    $[46] = t;
    $[47] = tempState;
    $[48] = t15;
  } else {
    t15 = $[48];
  }
  let t16;
  let t17;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = getNewslettersListNextjsUrl();
    t17 = <CloseIcon className="h-[20px] w-[20px]" />;
    $[49] = t16;
    $[50] = t17;
  } else {
    t16 = $[49];
    t17 = $[50];
  }
  let t18;
  if ($[51] !== t) {
    t18 = t("global.exit");
    $[51] = t;
    $[52] = t18;
  } else {
    t18 = $[52];
  }
  let t19;
  if ($[53] !== t18) {
    t19 = <NeutralButton as={LinkWithoutPrefetch} href={t16}>{t17}<span className="hidden lg:flex">{t18}</span></NeutralButton>;
    $[53] = t18;
    $[54] = t19;
  } else {
    t19 = $[54];
  }
  let t20;
  if ($[55] !== t15 || $[56] !== t19) {
    t20 = <div className="flex gap-3">{t15}{t19}</div>;
    $[55] = t15;
    $[56] = t19;
    $[57] = t20;
  } else {
    t20 = $[57];
  }
  let t21;
  if ($[58] !== t14 || $[59] !== t20) {
    t21 = <div className="flex flex-col items-center justify-between gap-5 sm:flex-row">{t14}{t20}</div>;
    $[58] = t14;
    $[59] = t20;
    $[60] = t21;
  } else {
    t21 = $[60];
  }
  let t22;
  if ($[61] !== attachmentsTempState || $[62] !== contactsSettings || $[63] !== errors || $[64] !== isLoading || $[65] !== newsletterData.mailing.id || $[66] !== newsletterData.sent || $[67] !== onChangeEmail || $[68] !== setAttachmentsTempState || $[69] !== setContactsSettings || $[70] !== tempState) {
    t22 = <DashboardMailEditor attachmentsTempState={attachmentsTempState} contactsSettings={contactsSettings} disabled={newsletterData.sent} errors={errors} isPreFetching={isLoading} isSwitchEditorButtonShown={true} onChangeContactsSettings={setContactsSettings} onChangeEmail={onChangeEmail} setAttachmentsTempState={setAttachmentsTempState} tempState={tempState} withContactsSettings={true} mailingId={newsletterData.mailing.id} />;
    $[61] = attachmentsTempState;
    $[62] = contactsSettings;
    $[63] = errors;
    $[64] = isLoading;
    $[65] = newsletterData.mailing.id;
    $[66] = newsletterData.sent;
    $[67] = onChangeEmail;
    $[68] = setAttachmentsTempState;
    $[69] = setContactsSettings;
    $[70] = tempState;
    $[71] = t22;
  } else {
    t22 = $[71];
  }
  let t23;
  if ($[72] !== t21 || $[73] !== t22) {
    t23 = <div className="flex flex-col gap-5">{t21}{t22}</div>;
    $[72] = t21;
    $[73] = t22;
    $[74] = t23;
  } else {
    t23 = $[74];
  }
  let t24;
  if ($[75] !== t) {
    t24 = t("dashboard.newsletter_editor.confirmation_message_before_exit");
    $[75] = t;
    $[76] = t24;
  } else {
    t24 = $[76];
  }
  const t25 = isDataSaved || newsletterData.sent;
  let t26;
  if ($[77] !== t24 || $[78] !== t25) {
    t26 = <ConfirmationModalBeforeExit confirmationText={t24} hideModal={t25} />;
    $[77] = t24;
    $[78] = t25;
    $[79] = t26;
  } else {
    t26 = $[79];
  }
  let t27;
  if ($[80] !== UnsavedEmailConfirmationModal || $[81] !== t23 || $[82] !== t26) {
    t27 = <>{t23}{t26}{UnsavedEmailConfirmationModal}</>;
    $[80] = UnsavedEmailConfirmationModal;
    $[81] = t23;
    $[82] = t26;
    $[83] = t27;
  } else {
    t27 = $[83];
  }
  return t27;
};